// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../shared/action-creators/latest-per-unit-measurements';
import {
    updateResponsibleAccountsDropDown,
    updateSpaClaimInputOnBlur
} from './claim-details';
import actions from '../../action-list';
import {canGetProductCustomer} from '../../../shared/services/privacy';
import {doesAccountHaveMatch} from '../../shared/services/claim-shared-helper';
import {getDetails} from '../../../product/shared/repositories';
import {getUnitKey} from '../../shared/services/get-unit-key';
import {readCustomer} from './get-customer-details';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readSpaTypes} from './get-spa-types';

const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, pin) =>

    dispatch => {

        if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

            updateResponsibleAccountsDropDown(productAccountId, dealerCollection, pin)(dispatch);
            readSpaTypes(productAccountId)(dispatch);
            dispatch(updateSpaClaimInputOnBlur('responsibleAccount', productAccountId));

        }

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

/* eslint-disable complexity */

export const readClaimProduct = (pin, resetUseAmounts) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            if (resetUseAmounts) {

                dispatch({
                    type: actions.RESET_CLAIM_SPA_USE_AMOUNT
                });

            }

            const accountId = getState().claims.spa.claim.responsibleAccount.account;
            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;
            const productAccountId = data.dealer.account;
            const useAmountUnit = getState().claims.spa.claim.useAmount.unit.key;

            dispatch({
                data,
                type: actions.SET_CLAIM_SPA_PRODUCT_DETAILS
            });

            if (!useAmountUnit) {

                const unitKey = getUnitKey(data);

                dispatch({
                    key: unitKey,
                    type: actions.UPDATE_CLAIM_SPA_USE_AMOUNT_UNIT,
                    unitCollection: data.useAmountAllowedUnits
                });

            }

            updateResponsibleAccount(accountId, productAccountId, dealerCollection, pin)(dispatch);

            if (canGetProductCustomer(data)) {

                readCustomer(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_SPA_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/get-product-details.js